import { render, staticRenderFns } from "./sendRejectManage.vue?vue&type=template&id=ebd03728"
import script from "./sendRejectManage.vue?vue&type=script&lang=js"
export * from "./sendRejectManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports